<div class="toaster-bg success d-flex justify-content-center">
  <mat-icon class="icon-success mr-1"></mat-icon>
  <span> {{title}}</span>
</div>
